import Gator from "gator";

import './Main.scss';

const SELECTOR = ".-js-field";

function toggle(node) {
    node.parentNode.classList[node.value ? "add" : "remove"]("form-has-value");
}


[...document.querySelectorAll(SELECTOR)].forEach(toggle);


Gator(document.documentElement).on("change", SELECTOR, function() {
    toggle(this);
});
